(()=>{
  const root=document.querySelector('[data-hf-care]');
  if(!root)return;
  const $=(selector,base=root)=>base.querySelector(selector);
  const $$=(selector,base=root)=>[...base.querySelectorAll(selector)];

  $$('[data-tab]').forEach(button=>button.addEventListener('click',()=>{
    const family=button.dataset.tab;
    $$('[data-tab]').forEach(item=>item.classList.toggle('active',item===button));
    $$('[data-family-row]').forEach(row=>{
      const matches=family==='all'||row.dataset.familyRow.split(' ').includes(family);
      row.hidden=!matches;
    });
  }));

  const coverage={
    home:{
      title:'Smart Home AIoT',
      intro:'Connected home-awareness hardware has one main-device period and a shorter accessory period.',
      facts:[['Main products','24 months'],['Power and mounting accessories','12 months']],
      points:[
        'Cameras, doorbells, floodlights, hubs, sensors and keypads are covered for eligible defects in materials and workmanship under normal use.',
        'Weather-rated products must remain within published ingress, temperature, installation and power requirements.',
        'A manufacturing defect affecting a rechargeable battery may be covered; ordinary runtime reduction with age and use is not, by itself, a defect.',
        'Reasonably necessary logs, sample footage or photographs may be requested and handled under the applicable privacy notice.'
      ]
    },
    audio:{
      title:'AI Audio & Videos',
      intro:'Main audio and display units receive longer hardware coverage than detachable accessories.',
      facts:[['Main units','24 months'],['Remotes, adapters and detachable cables','12 months']],
      points:[
        'Pictune, SODA, Minibar and Soundbar main units are covered for eligible defects in materials and workmanship under normal use.',
        'Display, speaker, control, power and connectivity hardware failures may be covered when caused by materials or workmanship.',
        'Pixels within the published display specification, normal speaker break-in, cosmetic aging and ordinary battery-runtime change are not hardware defects.',
        'Third-party content, voice assistants, streaming providers, codecs, cloud services and partner integrations are not guaranteed by the hardware warranty.'
      ]
    },
    wearable:{
      title:'Smart Wearable',
      intro:'LaLook and LaRing have main-device coverage plus product-specific fit, water and optical conditions.',
      facts:[['LaLook and LaRing main devices','24 months'],['Chargers, cases, cables and non-electronic accessories','12 months']],
      points:[
        'Eligible materials, assembly, hardware and necessary embedded-firmware defects are covered under normal published conditions.',
        'Normal scratches, finish changes, lens wear and ordinary battery-runtime reduction are not manufacturing defects.',
        'Water or sweat exposure is covered only within the published resistance rating and care instructions.',
        'For LaLook, third-party prescription lenses and optical services are outside the HOMA hardware warranty.'
      ]
    },
    lahear:{
      title:'LaHear',
      intro:'LaHear uses a dedicated policy for its left and right audio units, charging case and supplied accessories.',
      facts:[['Audio units and charging case','24 months'],['Charging cable and non-electronic accessories','12 months']],
      points:[
        'Manufacturing defects affecting charging, controls, microphones, speakers, connectivity or battery operation may be covered.',
        'Ordinary battery-capacity reduction, cosmetic wear, earwax or debris blockage, and sound changes resolved by required cleaning are not manufacturing defects.',
        'Sweat or water exposure is covered only within the published resistance rating and care instructions.',
        'Unless expressly authorized as a regulated device, LaHear is not a hearing aid or medical device.'
      ]
    }
  };

  const coverageRoot=$('[data-coverage-panel]');
  const renderCoverage=key=>{
    if(!coverageRoot||!coverage[key])return;
    const item=coverage[key];
    coverageRoot.innerHTML=`<h3>${item.title}</h3><p>${item.intro}</p><div class="coverage-facts">${item.facts.map(([label,value])=>`<div><b>${label}</b><span>${value}</span></div>`).join('')}</div><div class="coverage-copy"><h4>Product-specific conditions</h4><ul>${item.points.map(point=>`<li>${point}</li>`).join('')}</ul></div>`;
  };
  $$('[data-coverage]').forEach(button=>button.addEventListener('click',()=>{
    $$('[data-coverage]').forEach(item=>item.classList.toggle('active',item===button));
    renderCoverage(button.dataset.coverage);
  }));
  if(coverageRoot)renderCoverage('home');

  const returnWindows={home:45,pictune:60,audio:45,wearable:30,lahear:45};
  const checker=$('[data-return-checker]');
  checker?.addEventListener('submit',event=>{
    event.preventDefault();
    const channel=$('[name="channel"]',checker).value;
    const family=$('[name="family"]',checker).value;
    const dateValue=$('[name="deliveryDate"]',checker).value;
    const reason=$('[name="reason"]',checker).value;
    const status=$('[data-result-status]');
    const title=$('[data-result-title]');
    const copy=$('[data-result-copy]');
    const list=$('[data-result-list]');
    const set=(state,heading,message,items)=>{
      status.textContent=state;title.textContent=heading;copy.textContent=message;
      list.innerHTML=items.map(item=>`<li>${item}</li>`).join('');
    };
    if(!channel||!family||!dateValue||!reason){
      set('More information needed','Complete all four fields.','This quick check needs the purchase channel, product family, delivery date and reason.',['No information is submitted by this prototype.']);return;
    }
    if(reason==='damaged'||reason==='defective'){
      set('Support route','Start with HOMA Support.','Incorrect, damaged-on-arrival or potentially defective products follow the authorized support route and are not limited to the voluntary change-of-mind flow.',['Do not ship before receiving authorization.','HOMA pays reasonable authorized return shipping for a verified covered issue.','Keep proof of purchase and product information ready.']);return;
    }
    if(channel!=='homa'){
      const authorized=channel==='authorized';
      set(authorized?'Retailer return route':'Seller verification needed',authorized?'Start with the retailer that sold the product.':'Confirm that the seller is authorized.',authorized?'The voluntary HOMA direct-purchase return policy does not replace the retailer’s return policy. The limited warranty may still apply to an eligible new product from an authorized retailer.':'Unauthorized purchases are not covered by the voluntary return policy and may not qualify for the limited warranty.',['Use the retailer order confirmation.','Keep proof of purchase and serial number.','Contact HOMA Support if the product may have a covered defect.']);return;
    }
    const delivered=new Date(`${dateValue}T12:00:00`),today=new Date(),days=Math.max(0,Math.floor((today-delivered)/86400000)),windowDays=returnWindows[family];
    if(days<=windowDays){
      set('Likely within window',`${windowDays-days} day${windowDays-days===1?'':'s'} remaining in the draft voluntary window.`,`Based on the date entered, this direct HOMA purchase appears to be within the ${windowDays}-day voluntary return window. Final eligibility is confirmed after support reviews the order and product condition.`,['Request authorization before shipping.','After authorization, send the product within 14 calendar days unless HOMA or applicable law allows more time.','A prepaid standard return label is provided for an eligible U.S. direct-purchase voluntary return.']);
    }else{
      set('Outside voluntary window',`The draft ${windowDays}-day voluntary window appears to have ended.`,`The voluntary return window may have passed, but a defect, misdescription, safety issue or mandatory legal right may follow a different route.`,['Contact HOMA Support before taking action.','If the issue is a possible defect, review Warranty coverage.','Do not send the product without authorization.']);
    }
  });

  const backdrop=$('[data-modal-backdrop]');
  const closeModal=()=>{$$('.modal.open').forEach(modal=>modal.classList.remove('open'));backdrop?.classList.remove('open');document.body.style.overflow=''};
  $$('[data-modal-open]').forEach(button=>button.addEventListener('click',()=>{
    const modal=document.getElementById(button.dataset.modalOpen);if(!modal||!root.contains(modal))return;
    modal.classList.add('open');backdrop?.classList.add('open');document.body.style.overflow='hidden';$('.modal-close',modal)?.focus();
  }));
  $$('[data-modal-close]').forEach(button=>button.addEventListener('click',closeModal));
  backdrop?.addEventListener('click',closeModal);
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeModal()});
})();
